import { useMemo } from "react";
import { IApiContext } from "../../components/providers/Api-provider/ApiContext";
import { ITaggerQueries, TaggerQueries } from "./tagger-queries/tagger-queries";
import { BenchmarkQueries, IBenchmarkQueries } from "./benchmark/benchmark-queries";
import { IPlaidQueries, PlaidQueries } from "./plaid/plaid-queries";
import { GeneralQueries, IGeneralQueries } from "./general/general-queries";
import { ClientQueries, IClientQueries } from "./clients/clients-queries";

interface UseGetQueriesParams {
  apiContext: IApiContext;
}
export interface IGetQueries {
  taggerQueries: ITaggerQueries;
  benchmarkQueries: IBenchmarkQueries;
  plaidQueries: IPlaidQueries;
  generalQueries: IGeneralQueries;
  clientQueries: IClientQueries;
}

export const useGetQueries = (params: UseGetQueriesParams): IGetQueries => {
  const {
    apiContext: { altiusApi }
  } = params;

  const taggerQueries: ITaggerQueries = useMemo(() => new TaggerQueries({ api: altiusApi }), [altiusApi]);
  const benchmarkQueries: IBenchmarkQueries = useMemo(() => new BenchmarkQueries({ api: altiusApi }), [altiusApi]);
  const plaidQueries: IPlaidQueries = useMemo(() => new PlaidQueries({ api: altiusApi }), [altiusApi]);
  const generalQueries: IGeneralQueries = useMemo(() => new GeneralQueries({ api: altiusApi }), [altiusApi]);
  const clientQueries: IClientQueries = useMemo(() => new ClientQueries({ api: altiusApi }), [altiusApi]);

  return useMemo(
    () => ({
      taggerQueries,
      benchmarkQueries,
      plaidQueries,
      generalQueries,
      clientQueries
    }),
    [altiusApi]
  );
};

export default useGetQueries;
